export enum TextareaType {
	text,
	ips,
}
